import { FilterSelection } from 'src/app/core/classes/filterSelection';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { OperatorFunction, Observable, merge, Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  find,
  take,
} from 'rxjs/operators';
import { DataService } from 'src/app/core/services/data.service';

export interface OnSelectEvent {
  selectedItem: any,
  existsPreviousFilter: boolean
}

@Component({
  selector: 'dq-combo',
  templateUrl: './combo.component.html',
  styleUrls: ['./combo.component.scss'],
})
export class ComboComponent implements OnInit, OnChanges {
  @Output() selectedItemEvent = new EventEmitter<any>();
  selectedItem: any;

  @Output() unselectItemEvent = new EventEmitter<any>();

  @Input()
  public set items(items: any[] | null) {
    this._items = items;
    if (items!.length > 0) {
      this.getSelection();
    }
  }

  public get items(): any[] | null {
    return this._items;
  }

  @Input()
  id: string = '';

  @Input()
  label: string = '';

  @Input()
  public disabled: boolean = false;

  @Input()
  public selected: any;

  @Input()
  public filterType: any;

  @ViewChild('instance', { static: true })
  instance!: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  private _items: any[] | null = [];

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
  }

  formatter = (x: { name: string }) => x.name;

  search: OperatorFunction<string, readonly string[]> = (
    text$: Observable<string>
  ) => {
    const debouncedText$ = text$.pipe(
      debounceTime(200),
      distinctUntilChanged()
    );
    const clicksWithClosedPopup$ = this.click$.pipe(
      filter(() => !this.instance.isPopupOpen())
    );
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map((term) =>
        (term === ''
          ? this.items
            ? this.items
            : []
          : this.items
            ? this.items.filter(
              (v) =>
                v.name != null &&
                v.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(term.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) > -1
            )
            : []
        ).slice(0, 10)
      )
    );
  };

  emitSelected(event: any) {
    const onSelectEvent: OnSelectEvent = { selectedItem: event.item, existsPreviousFilter: false };
    this.selectedItemEvent.emit(onSelectEvent);
  }

  onBlurHandler(event: any) {
    if (this.selectedItem === undefined) {
      this.instance.writeValue('');
      this.unselectItemEvent.emit(null);
    }
  }

  ngOnChanges(changes: any) {
    this.instance.writeValue('');
    this.selectedItemEvent.emit(null);

    if (this.selected != null && this.items != null) {
      //console.log(this.selected);
      const result = this.items.find(({ id }) => id === this.selected);
      if (result) {
        this.selectedItem = { id: result.id, name: result.name };
      }
    }
  }

  private getSelection() {
    this.dataService.getFilterState().pipe(take(1)).subscribe((filterState) => {
      const selectedData = filterState[this.filterType as keyof FilterSelection];
      if (selectedData && this.items!.length > 0) {
        // this.selectedItem = {};
        this.selectedItem = this.items?.filter(x => x.id === selectedData)[0];
        const onSelectEvent: OnSelectEvent = { selectedItem: this.selectedItem, existsPreviousFilter: true };
        setTimeout(() => {
          this.selectedItemEvent.emit(onSelectEvent);
        }, 500);
      }
    });
  }
}
